<template>
  <div class="step-outline">
    <div class="step-label">{{ label }}</div>
    <StepProgress
      v-if="started"
      :displayAsPercent="displayAsPercent"
      :displayAsText="displayAsText"
      :total="task.total"
      :complete="task.complete"
    ></StepProgress>

    <HonorSystem
      v-if="task.type == 'honor_system'"
      :buttonText="task.button_text"
      :completed="task.completed"
      :title="task.title"
      :media="media"
      :description="task.description"
      :started="started"
      :stepId="task.step_id"
      @update="
        () => {
          $emit('update');
        }
      "
    ></HonorSystem>

    <ResourceList
      v-if="task.type == 'resource_list'"
      :resources="task.resources"
      :title="task.title"
      :media="media"
      :description="task.description"
    ></ResourceList>

    <CommunityShare
      v-if="task.type == 'community_posts'"
      :description="task.description"
      :title="task.title"
      :media="media"
      :started="started"
      :channel="task.channel"
      :tag="task.tag"
      :channelMember="task.member"
    ></CommunityShare>

    <ProgramOverview
      v-if="task.type == 'program'"
      :title="task.title"
      :image="task.image"
      :programId="task.id"
      :nextStart="task.nextStart"
      :description="task.description"
      :inProgram="task.enrolled"
      :started="started"
    ></ProgramOverview>

    <Webinar
      v-if="task.type == 'webinar'"
      :title="task.title"
      :media="media"
      :description="task.description"
      :started="started"
      :buttonText="task.button_text"
      :link="task.link"
    >
    </Webinar>
  </div>
</template>

<style lang="less" scoped>
.journey-link-styling() {
  color: orange !important;
  transition: color 0.2s ease-out;
  &:hover {
    color: white !important;
  }
}

.step-outline {
  .step-label {
    margin-bottom: 15px;
    min-height: 20px;
  }
}

/deep/ p {
  color: white;
  margin-bottom: 1em;

  a {
    .journey-link-styling;
  }
}

/deep/ .description a {
  .journey-link-styling;
}

/deep/ strong {
  font-weight: bold;
}

/deep/ em {
  font-style: italic;
}

/deep/ .description ol {
  padding-left: 20px;
  margin-bottom: 1em;
}

/deep/ .description ul {
  padding-left: 20px;
  list-style-type: disc;
  margin-bottom: 1em;
}
</style>

<script>
import ResourceList from "@/journeys/ResourceList";
import ProgramOverview from "@/journeys/ProgramOverview";
import CommunityShare from "@/journeys/CommunityShare";
import Webinar from "@/journeys/Webinar";
import HonorSystem from "@/journeys/HonorSystem";
import StepProgress from "@/journeys/StepProgress";
export default {
  components: {
    ResourceList,
    CommunityShare,
    ProgramOverview,
    Webinar,
    HonorSystem,
    StepProgress,
  },
  props: ["task", "label", "started", "media"],
  computed: {
    displayAsPercent() {
      return this.task.type == "program";
    },
    displayAsText() {
      return ["webinar", "honor_system"].includes(this.task.type);
    },
  },
};
</script>
